import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { CardMask } from '../card-mask/card-mask';

export interface SummaryBlockData {
  title: string;
  bgColor: string;
  number: number | string;
  icon: string;
  tooltipText?: string;
}

@Component({
  selector: 'app-summary-blocks',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, CardMask],
  templateUrl: './summary-blocks.html',
  styleUrls: ['./summary-blocks.scss']
})
export class SummaryBlocks {
  @Input() data!: SummaryBlockData;
  @Input() hasMask: boolean = false;
  @Output() openInfoModal = new EventEmitter<{title: string, message: string}>();

  // Detecta se é mobile/tablet (até 1024px)
  isMobile(): boolean {
    return window.innerWidth <= 1024;
  }

  getTextColor(): string {
    return this.data.bgColor === '#ffffff' ? '#001E50' : '#ffffff';
  }

  onInfoButtonClick(event: Event): void {
    event.stopPropagation();

    // Só emite evento se for mobile/tablet
    if (this.isMobile()) {
      this.openInfoModal.emit({
        title: this.data.title,
        message: this.data.tooltipText || 'Informações adicionais'
      });
    }
  }
}
